const getters = {
	userData: (state) => state.userVUEX.userData,
	adminID: (state) => state.userVUEX.adminID,
};

export default getters;
